/* eslint-disable jsx-a11y/label-has-associated-control */
import classNames from 'classnames';
import React from 'react';
import classes from './styles.module.scss';

const colors = {
  red: [0.5, 1, 1.5, 2],
  orange: [2.5, 3],
  green: [3.5, 4],
  blue: [4.5, 5],
};

export default function Stars({
  stars,
  setStars,
  name = 'rating',
  idPrefix,
  readonly,
}) {
  const handleChange = (event) => {
    if (readonly) return;
    setStars(+event.target.value);
  };

  return (
    <div
      className={classNames(classes.stars, {
        [classes.blue]: colors.blue.includes(stars),
        [classes.green]: colors.green.includes(stars),
        [classes.orange]: colors.orange.includes(stars),
        [classes.red]: colors.red.includes(stars),
        [classes.readonly]: readonly,
      })}
    >
      <input
        type="radio"
        name={name}
        value="5"
        id={`${idPrefix || name}-5`}
        onChange={(event) => handleChange(event)}
        checked={stars === 5}
      />
      <label htmlFor={`${idPrefix || name}-5`} className={classes.star} />
      <input
        type="radio"
        name={name}
        value="4.5"
        id={`${idPrefix || name}-4_5`}
        onChange={(event) => handleChange(event)}
        checked={stars === 4.5}
      />
      <label htmlFor={`${idPrefix || name}-4_5`} className={classes.halfStar} />

      <input
        type="radio"
        name={name}
        value="4"
        id={`${idPrefix || name}-4`}
        onChange={(event) => handleChange(event)}
        checked={stars === 4}
      />
      <label htmlFor={`${idPrefix || name}-4`} className={classes.star} />
      <input
        type="radio"
        name={name}
        value="3.5"
        id={`${idPrefix || name}-3_5`}
        onChange={(event) => handleChange(event)}
        checked={stars === 3.5}
      />
      <label htmlFor={`${idPrefix || name}-3_5`} className={classes.halfStar} />

      <input
        type="radio"
        name={name}
        value="3"
        id={`${idPrefix || name}-3`}
        onChange={(event) => handleChange(event)}
        checked={stars === 3}
      />
      <label htmlFor={`${idPrefix || name}-3`} className={classes.star} />
      <input
        type="radio"
        name={name}
        value="2.5"
        id={`${idPrefix || name}-2_5`}
        onChange={(event) => handleChange(event)}
        checked={stars === 2.5}
      />
      <label htmlFor={`${idPrefix || name}-2_5`} className={classes.halfStar} />

      <input
        type="radio"
        name={name}
        value="2"
        id={`${idPrefix || name}-2`}
        onChange={(event) => handleChange(event)}
        checked={stars === 2}
      />
      <label htmlFor={`${idPrefix || name}-2`} className={classes.star} />
      <input
        type="radio"
        name={name}
        value="1.5"
        id={`${idPrefix || name}-1_5`}
        onChange={(event) => handleChange(event)}
        checked={stars === 1.5}
      />
      <label htmlFor={`${idPrefix || name}-1_5`} className={classes.halfStar} />

      <input
        type="radio"
        name={name}
        value="1"
        id={`${idPrefix || name}-1`}
        onChange={(event) => handleChange(event)}
        checked={stars === 1}
      />
      <label htmlFor={`${idPrefix || name}-1`} className={classes.star} />
      <input
        type="radio"
        name={name}
        value="0.5"
        id={`${idPrefix || name}-0_5`}
        onChange={(event) => handleChange(event)}
        checked={stars === 0.5}
      />
      <label htmlFor={`${idPrefix || name}-0_5`} className={classes.halfStar} />
    </div>
  );
}
